<template>
  <div id="main-content" class="main-content" ref="printMe">
    <div class="main-item" id="main-item">
      <div class="basic__block">
        <div class="download__btn">
          <a class="main-button" v-on:click="downloadResult">{{ $t('identity_report_result_download_button') }}</a>
        </div>
        <div class="basic__block__title">
          <img class="witcher__logo__dark" :src="`${$baseUrl}witcher_logo_dark.png`" />
          <span>{{ $t(`identity_report_${scenario}_title`) }}</span>
        </div>
        <div class="basic__block__content">
          {{ $t('identity_report_brand_name') }}: {{ $store.state.license.brand_name }}
        </div>
        <div class="basic__block__content">{{ $t('identity_report_current_time') }}: {{ currentDateTime() }}</div>
        <div class="basic__block__hint mt-5">{{ $t('identity_report_hint') }}</div>

        <div class="number mt-30">{{ number }}</div>
      </div>
      <div class="factor__detail__block mt-20" v-for="category in filteredFactorsCategory" :key="category">
        <div class="content__block" v-if="category === '1_number_info'">
          <div class="number__detail__title">{{ $t(`identity_report_category_${category}`) }}</div>
          <div class="number__detail mt-15">
            <div v-for="(feature, index) in identityReportResult[category]" :key="index">
              <div v-if="feature.name === 'status_verify_yn'">
                ▪︎ {{ $t(`identity_report_${scenario}_${feature.name}_name`) }}：{{
                  $t(`identity_report_${scenario}_${feature.name}_result_${feature.result}`)
                }}
              </div>
              <div v-else>
                ▪︎ {{ $t(`identity_report_${scenario}_${feature.name}_name`) }}：<span v-if="feature.result">{{
                  feature.result
                }}</span
                ><span v-else>-</span>
              </div>
            </div>
          </div>
        </div>
        <div class="factor__block" v-else>
          <div class="factor__title">{{ $t(`identity_report_category_${category}`) }}</div>
          <div class="factor__block__list factor__block__head mt-20">
            <div class="factor__block__list-item feature_name">{{ $t('identity_report_table_header_name') }}</div>
            <div class="factor__block__list-item feature_result">{{ $t('identity_report_table_header_result') }}</div>
            <div class="factor__block__list-item feature_desc">{{ $t('identity_report_table_header_desc') }}</div>
          </div>
          <div
            class="factor__block__list factor__block__content"
            v-for="(feature, index) in sortingWithI18nOrder(identityReportResult[category])"
            :key="index"
          >
            <div class="factor__block__list-item feature_name">
              {{ $t(`identity_report_${scenario}_${feature.name}_name`) }}
            </div>
            <div class="factor__block__list-item feature_result">
              <span :class="[`level__circle__${feature.result}`]" class="mr-10"></span>
              {{ $t(`identity_report_${scenario}_result_${feature.result}`) }}
            </div>
            <div class="factor__block__list-item feature_desc">
              <span v-if="feature.result == 1">-</span>
              <span v-else>{{ $t(`identity_report_${scenario}_${feature.name}_${feature.result}_desc`) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="credit__risk__block mt-40" v-if="hasCreditRisk">
        <div class="credit__risk__result" v-for="(feature, index) in identityReportResult['credit_risk']" :key="index">
          {{ $t(`identity_report_${scenario}_${feature.name}_name`) }}：{{ feature.result }}
        </div>
        <div class="credit__risk__desc mt-10" v-html="$t('identity_report_credit_risk_desc')"></div>
        
        <!-- Model v3 模型解釋力 -->
        <div class="content__block mt-20" v-if="identityReportResult['model_interpret']">
          <div class="factor__title">{{ $t('model_interpret_category_title') }}</div>
          <div class="factor__block__list factor__block__head mt-20">
            <div class="factor__block__list-item feature_name">{{ $t('identity_report_table_header_name') }}</div>
            <div class="factor__block__list-item feature_result">{{ $t('identity_report_table_header_result') }}</div>
            <div class="factor__block__list-item feature_desc">{{ $t('identity_report_table_header_desc') }}</div>
          </div>
          
          <!-- 信用評分 -->
          <div class="factor__block__list factor__block__content" v-if="getModelInterpretItem('credit_score')">
            <div class="factor__block__list-item feature_name">
              {{ $t('credit_score_name') }}
            </div>
            <div class="factor__block__list-item feature_result">
              {{ getModelInterpretItem('credit_score').result }}
            </div>
            <div class="factor__block__list-item feature_desc">
              {{ $t('credit_score_desc') }}
            </div>
          </div>
          
          <!-- 模型名稱 -->
          <div class="factor__block__list factor__block__content" v-if="getModelInterpretItem('model_name')">
            <div class="factor__block__list-item feature_name">
              {{ $t('model_name_name') }}
            </div>
            <div class="factor__block__list-item feature_result">
              {{ getModelInterpretItem('model_name').result }}
            </div>
            <div class="factor__block__list-item feature_desc">
              <span>-</span>
            </div>
          </div>
          
          <!-- Top 10 features 評等正負前十大影響的因子清單 -->
          <div class="factor__title mt-20">{{ $t('top_10_features_name') }}</div>
          <div class="factor__block__list factor__block__head mt-20">
            <div class="factor__block__list-item feature_name">{{ $t('identity_report_table_header_name') }}</div>
            <div class="factor__block__list-item feature_result">{{ $t('identity_report_table_header_result') }}</div>
            <div class="factor__block__list-item feature_desc">{{ $t('identity_report_table_header_desc') }}</div>
          </div>

          <div class="factor__block__list factor__block__content" v-for="(feature, index) in getSortedTopFeatures()" :key="index">
            <div class="factor__block__list-item feature_name">
              {{ $t(`${feature[0]}_name`) }}
            </div>
            <div class="factor__block__list-item feature_result" :class="feature[1] >= 0 ? 'positive_impact' : 'negative_impact'">
              {{ feature[1] }}
            </div>
            <div class="factor__block__list-item feature_desc">
              <span>-</span>
            </div>
          </div>
        </div>
        <div class="chart__block mt-20">
          <credit-risk-chart
            :width="500"
            :height="400"
            :styles="{ border: '2px solid #000', padding: '20px' }"
          ></credit-risk-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import VueCharts from 'vue-chartjs';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-plugin-trendline';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  name: 'IdentityReportDetailResult',
  data() {
    return {
      scenario: this.$store.state.license.scenario[0],
    };
  },
  props: {
    number: String,
    identityReportResult: Object,
  },
  computed: {
    filteredFactorsCategory() {
      let filtered = {};
      for (var category in this.identityReportResult) {
        if (category !== 'credit_risk' && category !== 'model_interpret') {
          filtered[category] = this.identityReportResult[category];
        }
      }
      return Object.keys(filtered).sort(this.sortingIdentityReportFactors);
    },
    hasCreditRisk: function () {
      return this.containsKey(this.identityReportResult || {}, 'credit_risk');
    },
  },
  methods: {
    getModelInterpretItem(name) {
      if (this.identityReportResult && this.identityReportResult['model_interpret']) {
        return this.identityReportResult['model_interpret'].find(item => item.name === name);
      }
      return null;
    },
    getSortedTopFeatures() {
      const topFeaturesItem = this.getModelInterpretItem('top_10_features');
      if (topFeaturesItem && topFeaturesItem.result) {
        // 將物件轉換為陣列並按絕對值排序
        const featuresArray = Object.entries(topFeaturesItem.result);
        return featuresArray.sort((a, b) => {
          // 從大到小排序
          return b[1] - a[1];
        });
      }
      return [];
    },
    currentDateTime() {
      return moment().tz('Asia/Taipei').format('YYYY-MM-DD HH:mm:ss');
    },
    downloadResult: function () {
      const el = this.$refs.printMe;
      el.scrollTop = 0;

      const origOverflow = el.style.overflow;
      const origHeight = el.style.height;
      const origMaxHeight = el.style.maxHeight;
      el.style.overflow = 'visible';
      el.style.height = 'auto';
      el.style.maxHeight = 'none';

      const restoreStyle = () => {
        el.style.overflow = origOverflow;
        el.style.height = origHeight;
        el.style.maxHeight = origMaxHeight;
      };

      const nextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));
      const waitFontsReady = () => {
        if (document.fonts && document.fonts.ready) {
          return document.fonts.ready;
        }
        return Promise.resolve();
      };

      const doCapture = () => {
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 16; // 頁面邊距
        const overlap = 6; // 頁面重疊高度，避免重疊造成尾端只剩極小高度，產生幾乎空白的最後一頁
        const contentWidth = pageWidth - margin * 2;
        const contentHeight = pageHeight - margin * 2;
        const rect = el.getBoundingClientRect();
        const sourceWidth = el.scrollWidth;
        const totalHeight = el.scrollHeight;
        const scale = 1.1;
        // 計算每頁在原始 DOM 座標可容納的高度，避免建立超長 canvas 導致空白頁
        const sliceHeight = Math.max(1, Math.floor((contentHeight * sourceWidth) / contentWidth));

        const renderPage = (offsetY, isFirstPage) => {
          if (offsetY >= totalHeight) {
            pdf.save(`witcherfin_identity_report_${this.number}.pdf`);
            return Promise.resolve();
          }

          const currentSliceHeight = Math.min(sliceHeight, totalHeight - offsetY);
          return html2canvas(document.body, {
            backgroundColor: '#ffffff',
            useCORS: true,
            scale,
            x: Math.floor(rect.left + window.scrollX),
            y: Math.floor(rect.top + window.scrollY + offsetY),
            width: Math.ceil(sourceWidth),
            height: Math.ceil(currentSliceHeight),
            windowWidth: document.documentElement.clientWidth,
            windowHeight: document.documentElement.clientHeight,
          }).then((canvas) => {
            const imageData = canvas.toDataURL('image/jpeg', 0.95);
            const imageHeight = (contentWidth * canvas.height) / canvas.width;

            if (!isFirstPage) {
              pdf.addPage();
            }
            pdf.addImage(imageData, 'JPEG', margin, margin, contentWidth, imageHeight, undefined, 'FAST');

            const nextOffsetY = Math.min(totalHeight, offsetY + currentSliceHeight - overlap);
            const remainHeight = totalHeight - nextOffsetY;
            // 避免重疊造成尾端只剩極小高度，產生幾乎空白的最後一頁
            if (remainHeight <= overlap + 2) {
              pdf.save(`witcherfin_identity_report_${this.number}.pdf`);
              return Promise.resolve();
            }
            if (nextOffsetY <= offsetY) {
              pdf.save(`witcherfin_identity_report_${this.number}.pdf`);
              return Promise.resolve();
            }
            return renderPage(nextOffsetY, false);
          });
        };

        return renderPage(0, true);
      };

      this.$nextTick(() => {
        nextFrame()
          .then(nextFrame)
          .then(waitFontsReady)
          .then(() => new Promise((resolve) => setTimeout(resolve, 150)))
          .then(doCapture)
          .catch((err) => {
            console.error('PDF export failed:', err);
          })
          .finally(restoreStyle);
      });
    },
    sortingWithI18nOrder: function(data) {
      const $ = this;
      let copy = [...data]
      return copy.sort(function(a, b) {
        let i18a = $.$i18n.t(`identity_report_${$.scenario}_${a.name}_name`)
        let i18b = $.$i18n.t(`identity_report_${$.scenario}_${b.name}_name`)

        let lenA = i18a.length;
        let lenB = i18b.length;

        let prefixLength = 0;
        while (prefixLength < lenA && prefixLength < lenB && i18a[prefixLength] === i18b[prefixLength]) {
          prefixLength++;
        }

        if (prefixLength === lenA && prefixLength === lenB) {
          return 0;
        } else if (prefixLength === lenA || prefixLength === lenB) {
          return lenA - lenB;
        } else {
          const remainLengthA = lenA - prefixLength;
          const remainLengthB = lenB - prefixLength;
          return remainLengthA - remainLengthB;
        }
      })
    }
  },
  components: {
    'credit-risk-chart': {
      extends: VueCharts.Bar,
      mounted() {
        const self = this;
        let dashImage = new Image(16, 2);
        dashImage.src = this.$baseUrl + 'img_dash.png';
        
        // 渲染圖表
        const renderChartWithImage = (image) => {
          self.addPlugin(ChartJsPluginDataLabels);
          self.renderChart(
            {
              labels: ['A', 'B', 'C', 'D', 'E'],
              datasets: [
                {
                  type: 'line',
                  label: '平均違約線',
                  data: [1, 1, 1, 1, 1],
                  fill: false,
                  borderDash: [10, 10],
                  borderColor: '#aeaeae',
                  borderWidth: 2,
                  pointRadius: 0,
                  datalabels: {
                    display: false,
                  },
                },
                {
                  type: 'bar',
                  label: '',
                  backgroundColor: '#640061',
                  // backgroundColor: '#BB93BA',
                  data: [0.4, 0.6, 0.9, 1.2, 3.2],
                  // trendlineLinear: {
                  //   style: "#3d003c",
                  //   lineStyle: "solid",
                  //   width: 2,
                  //   projection: true,
                  // },
                  datalabels: {
                    color: '#fff',
                    anchor: 'end',
                    align: 'start',
                  },
                  barPercentage: 0.8,
                },
              ],
            },
            {
              scales: {
                xAxes: [
                  {
                    scaleLabel: {
                      display: true,
                      labelString: '評等',
                      fontSize: 16,
                    },
                    gridLines: {
                      display: false,
                    },
                  },
                ],
                yAxes: [
                  {
                    scaleLabel: {
                      display: true,
                      labelString: '幾倍違約率',
                      fontSize: 16,
                    },
                    ticks: {
                      stepSize: 1,
                    },
                  },
                ],
              },
              title: {
                display: true,
                text: '違約倍率分佈',
                fontSize: 24,
              },
              responsive: false,
              maintainAspectRatio: false,
              legend: {
                labels: {
                  filter: item => {
                    // skip without label text
                    return !!item.text.length
                  },
                  usePointStyle: true, 
                  generateLabels: chart => chart.data.datasets.map((dataset, i) => ({
                    datasetIndex: i,
                    text: dataset.label,
                    pointStyle: image,
                  })) 
                }
              }
            }
          );
        };
        
        // 等圖片加載完成後再渲染圖表
        dashImage.onload = () => {
          renderChartWithImage(dashImage);
        };
        
        // 處理圖片加載失敗的情況
        dashImage.onerror = () => {
          console.warn('Failed to load img_dash.png, using Canvas fallback');
          // 如果圖片加載失敗，使用 Canvas 繪製虛線作為備用方案
          const canvas = document.createElement('canvas');
          canvas.width = 16;
          canvas.height = 2;
          const ctx = canvas.getContext('2d');
          ctx.strokeStyle = '#aeaeae';
          ctx.setLineDash([4, 4]);
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(0, 1);
          ctx.lineTo(16, 1);
          ctx.stroke();
          
          const fallbackImage = new Image();
          fallbackImage.src = canvas.toDataURL();
          fallbackImage.onload = () => {
            renderChartWithImage(fallbackImage);
          };
          fallbackImage.onerror = () => {
            // 如果 Canvas 也失敗，使用預設樣式（不使用圖片）
            renderChartWithImage(null);
          };
        };
      },
    },
  },
};
</script>

<style scoped>
.main-content {
  display: flex;
  box-sizing: border-box;
  flex-basis: 80%;
  flex-direction: column;
  background-color: #ffffff;
  overflow-y: scroll;
  z-index: 1;
  padding: 40px 80px;
}

.main-item {
  width: 100%;
}

.basic__block {
  position: relative;
  justify: center;
}

.basic__block__title {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
}

.witcher__logo__dark {
  width: 180px;
}

.basic__block__content {
  font-size: 12px;
}

.basic__block__hint {
  font-size: 12px;
  color: #aeaeae;
}

.download__btn {
  position: absolute;
  right: 0;
}

.number {
  font-size: 48px;
  font-weight: 600;
  color: #000000;
}

.number__detail {
  flex-basis: 100%;
  font-size: 14px;
  color: #000000;
}

.factor__detail__block {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
}

.factor__block {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  background-color: #ffffff;
}

.content__block {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
}

.factor__block__list {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  justify-content: center;
}

.factor__block__list-item.feature_name {
  width: 40%;
  padding: 0 20px;
  word-break: break-all;
}

.factor__block__list-item.feature_result {
  width: 10%;
  padding: 0 20px;
  word-break: break-all;
}

.factor__block__list-item.feature_desc {
  width: 50%;
  padding: 0 20px;
  word-break: break-all;
}

.factor__title,
.number__detail__title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

.factor__block__head {
  height: 30px;
  background-color: #161616;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.factor__block__content {
  min-height: 30px;
  font-size: 14px;
  color: #000000;
  border-bottom: 1px solid #d8d8d8;
}

.level__circle__3 {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #870136;
  border-radius: 50%;
}

.level__circle__2 {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #b49624;
  border-radius: 50%;
}

.level__circle__1 {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #378619;
  border-radius: 50%;
}

.positive_impact {
  color: #378619;
  font-weight: 600;
}

.negative_impact {
  color: #870136;
  font-weight: 600;
}

.credit__risk__block {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
}

.credit__risk__result {
  flex-basis: 100%;
  font-size: 36px;
  font-weight: 600;
}

.credit__risk__desc {
  flex-basis: 100%;
  font-size: 14px;
}

.chart__block {
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  align-items: center;
}

#canvas-img {
  display: none;
}

#bar-chart {
  border: 1px solid #000;
}
</style>
